import { render, staticRenderFns } from "./CreateWaybill.vue?vue&type=template&id=4a64d715&scoped=true&"
import script from "./CreateWaybill.vue?vue&type=script&lang=js&"
export * from "./CreateWaybill.vue?vue&type=script&lang=js&"
import style0 from "./CreateWaybill.vue?vue&type=style&index=0&id=4a64d715&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64d715",
  null
  
)

export default component.exports